import { useEffect } from 'react';
import i18next from 'i18next';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { loadCatalog } from '@/lib/i18n';
import { applyDocumentLanguage, DEFAULT_LOCALE, getLocale } from '@/lib/locale';

export const LocaleCatalog = () => {
    const { featureFlags } = useFeatureFlags();
    const enabled = featureFlags.FEATURE_FLAG_SPANISH_TRANSLATION === true;

    useEffect(() => {
        if (!enabled) {
            return;
        }

        // English is bundled, so there is never a request to make for it.
        const locale = getLocale();
        if (locale === DEFAULT_LOCALE) {
            return;
        }

        applyDocumentLanguage(locale);
        // The bundle arrives after init, so the language switch has to wait for the fetch or
        // i18next reports the locale while still holding only English.
        void loadCatalog(locale).then(() => i18next.changeLanguage(locale));
    }, [enabled]);

    return null;
};
